import { initImaApp, clearImaApp } from './app';
import { getConfig, setConfig } from './configuration';

export { getConfig, setConfig, initImaApp, clearImaApp };
